import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentResult({ ok }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(ok ? "checking" : "cancelled");

  useEffect(() => {
    if (!ok || !sessionId) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setState("paid");
        if (data.status === "expired") return setState("failed");
      } catch {
        // keep polling
      }
      if (tries < 15) timer = setTimeout(poll, 2000);
      else setState("slow");
    };
    poll();
    return () => clearTimeout(timer);
  }, [ok, sessionId]);

  const view = {
    checking: [<Loader2 key="i" className="animate-spin text-[#3d644e]" />, "Confirming your payment…", "This usually takes a few seconds."],
    paid: [<CheckCircle2 key="i" className="text-[#3d644e]" />, "You're all set.", "Your seller plan is active and your 28 credits are ready. During the free period, nothing is charged until 1 January 2027."],
    slow: [<Loader2 key="i" className="text-[#c5903b]" />, "Still confirming.", "Your payment is processing. Your seller page will update shortly."],
    failed: [<XCircle key="i" className="text-[#991b1b]" />, "Payment didn't go through.", "No money was taken. You can try again from your seller page."],
    cancelled: [<XCircle key="i" className="text-[#5a665e]" />, "Checkout cancelled.", "No money was taken. You can subscribe any time."],
  }[state];

  return (
    <div className="max-w-xl mx-auto px-5 sm:px-8 pt-20" data-testid="payment-result-page" data-state={state}>
      <div className="border border-[#e2dcd4] bg-white p-10">
        {view[0]}
        <h1 className="mt-4 text-3xl text-[#1f402b]" data-testid="payment-result-title">{view[1]}</h1>
        <p className="mt-3 text-[#5a665e]">{view[2]}</p>
        <Link to="/sell" className="mt-8 inline-block bg-[#1f402b] text-white px-6 py-3 text-sm hover:bg-[#2c5a3d]" data-testid="payment-result-sell-link">Go to your seller page</Link>
      </div>
    </div>
  );
}
